export default {
  getTestimonials: (state) => state.testimonials,
  getTestimonialsIsError: (state) => state.status.isError,
  getTestimonialsError: (state) => state.status.error,
  getTestimonialsIsLoading: (state) => state.status.isLoading
};
